import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';

import { WalkthroughPopover } from '../../common/components';
import {
  AggregateBlock,
  ChartContent,
  DataFilter,
  EinsteinRecommendation,
  EmailPerformance,
  FrequencyCap
} from './';
import './DashboardBody.scss';

export class DashboardBody extends Component {
  drawSidebar(dataExtension) {
    const {
      lookback,
      emailType,
      eventType,
      undersaturated,
      oversaturated,
      openRateWeight,
      clickRateWeight,
      unsubscribePenaltyFactor,
      rangeStart,
      rangeEnd
    } = dataExtension.dataFilter;
    const { advancedSliders } = dataExtension;
    const { frequencies } = this.props.frequencies.data;
    const lastFreqency = frequencies[frequencies.length - 1];
    return (
      <div>
        <DataFilter
          lookback={lookback}
          emailType={emailType}
          actions={this.props.actions}
          frequencyMax={lastFreqency ? Number(lastFreqency.numEmail) : 100}
          rangeStart={rangeStart}
          rangeEnd={rangeEnd}
        />
        <EmailPerformance
          eventType={eventType}
          openRateWeight={openRateWeight}
          clickRateWeight={clickRateWeight}
          unsubscribePenaltyFactor={unsubscribePenaltyFactor}
          advancedSliders={advancedSliders}
          actions={this.props.actions}
          {...this.props}
        />
        <FrequencyCap
          undersaturated={undersaturated}
          oversaturated={oversaturated}
          einsteinFrequencyRecs={this.props.dataExtension.einsteinFrequencyRecs}
          actions={this.props.actions}
          {...this.props}
        />
      </div>
    );
  }

  render() {
    const { formatMessage, formatNumber } = this.props.intl;
    const {
      actions,
      dataExtension,
      einsteinRecommendations,
      frequencies,
      ftux,
      location,
      modals
    } = this.props;
    const {
      oversaturationRate,
      undersaturationRate
    } = frequencies.data.aggregates;
    const numberOptions = {
      style: 'percent',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    };
    return (
      <div className="slds-card slds-grid card-top-connect">
        <div className="dashboard-aggregates-chart slds-col slds-size_3-of-4">
          <div className="dashboard-chart-cards slds-grid slds-gutters_direct-x-small">
            <div className="slds-col slds-size_1-of-2">
              <div className="slds-card">
                <EinsteinRecommendation
                  dataFilter={dataExtension.dataFilter}
                  einsteinFrequencyRecs={dataExtension.einsteinFrequencyRecs}
                />
                <WalkthroughPopover
                  step={ftux.steps.get('einsteinFrequencyRecommendations')}
                  numSteps={ftux.numSteps}
                  position="right"
                  actions={this.props.actions}
                />
              </div>
            </div>
            <div className="slds-col slds-size_1-of-2">
              <div className="dashboard-aggregates-container slds-card">
                {!frequencies.isLoading &&
                typeof oversaturationRate !== 'undefined' &&
                typeof undersaturationRate !== 'undefined' ? (
                  <div className="slds-card-content slds-grid">
                    <AggregateBlock
                      title={formatMessage({
                        id: 'DashboardBody.aggregates.undersaturation.title'
                      })}
                      tooltip={formatMessage({
                        id: 'DashboardBody.aggregates.undersaturation.tooltip'
                      })}
                      value={formatNumber(undersaturationRate, numberOptions)}
                    />
                    <AggregateBlock
                      title={formatMessage({
                        id: 'DashboardBody.aggregates.oversaturation.title'
                      })}
                      tooltip={formatMessage({
                        id: 'DashboardBody.aggregates.oversaturation.tooltip'
                      })}
                      value={formatNumber(oversaturationRate, numberOptions)}
                    />
                  </div>
                ) : null}
              </div>
            </div>
          </div>
          <div className="frequency-chart-container slds-card">
            <div className="slds-card-content">
              {!frequencies.isLoading && frequencies.data ? (
                <ChartContent
                  actions={actions}
                  location={location}
                  frequencies={frequencies}
                  chartParams={dataExtension.chartParams}
                  modals={modals}
                />
              ) : null}
            </div>
            <WalkthroughPopover
              step={ftux.steps.get('emailFrequencyChart')}
              numSteps={ftux.numSteps}
              actions={this.props.actions}
            />
          </div>
        </div>
        <div className="dashboard-controls slds-col slds-size_1-of-4">
          {!dataExtension.isLoading && !einsteinRecommendations.isLoading
            ? this.drawSidebar(dataExtension)
            : null}
        </div>
      </div>
    );
  }
}

DashboardBody.propTypes = {
  children: PropTypes.element,
  location: PropTypes.object.isRequired,
  frequencies: PropTypes.object,
  dataExtension: PropTypes.object,
  einsteinRecommendations: PropTypes.object,
  ftux: PropTypes.object,
  actions: PropTypes.object,
  modals: PropTypes.object,
  intl: intlShape.isRequired
};

export default injectIntl(DashboardBody);
